import {AlpineComponent} from 'alpinejs';

type SolrSearch = {}

export default (): AlpineComponent<SolrSearch> => ({
  init() {
    const pageLinks = document.querySelectorAll('.page-link');
    const solrContent = this.$refs.solrContent;
    if (pageLinks && solrContent) {
      pageLinks.forEach((link) => {
        link.addEventListener('click', () => {
          window.scrollTo({
            top: solrContent.offsetTop - 300,
            behavior: 'smooth'
          });
        });
      });
    }

    // #tx-solr-search-status sits outside the ajax-swapped #tx-solr-search, so it survives the
    // swap and can carry a stable aria-live announcement; the swap target itself gets destroyed
    // and recreated on every pagination/facet/sorting/search request and would never reliably
    // announce. Also focus it, since the swap otherwise silently drops keyboard focus.
    window.addEventListener('ajax:after', () => {
      const status = document.getElementById('tx-solr-search-status');
      const summary = document.getElementById('tx-solr-search-summary');
      if (status && summary) {
        status.textContent = summary.textContent?.trim() ?? '';
        status.focus();
      }
    }, {once: true});
  }
});
